<!-- @component
  General input field in Pentelion App
-->

{#if separate && !unlabeled}
	<label for={field} {separate} data-help={help}>{label}</label>
{/if}
<div class="inputBox {className}">
	<select id={field} data-help={help} bind:value={value} {disabled} class:default={value === defaultval} style={styleDefs} {onchange}>
		{#if Array.isArray(options)}
			<!--{#if defaultval}-->
			<!--	<option value="" disabled selected>{defaultval}</option>-->
			<!--{/if}-->
			{#each options as opt}
				{#if typeof opt === 'string'}
					<option value={opt} selected={opt === value}>{opt}</option>
				{:else}
					<option value={opt.ID} selected={opt.ID === value}>{opt.name}</option>
				{/if}
			{/each}
		{:else}
			{#each Object.keys(options) as group}
				<optgroup label={group}>  <!-- on:click={() => expanded = group}>  -->
					{#if true}   <!-- expanded === group}  see: https://stackoverflow.com/questions/52156973/collapse-expand-optgroup-using-select2 -->
						{#each options[group] as opt}
							<option value={opt.ID}>{opt.name}</option>
						{/each}
					{/if}
				</optgroup>
			{/each}
		{/if}
	</select>
	{#if !separate && !unlabeled && label}
		<label for={field} data-help={help}>{label}</label>
	{/if}
</div>


<script>
    import {fieldLabels} from "../core.js";

	let {field,
			value = $bindable(), defaultval = "",
			options = [],			// either array of strings (=label & ID) or array of {name, ID}  or grouped array of {name,ID}
			separate = false, disabled = false, unlabeled = false,
			onchange = null,
			class: className = '', style: styleDefs = '',
			help = null} = $props()		// help: documentation topic if it differs from field

	const label = fieldLabels[field] ?? field
	// const optionsList = (Array.isArray(options)) ? options : Object.entries(options).map(([label,value]) => { return {label: label, value: value} })

	// $inspect(`SELECT - options`, options)

</script>

<style lang="sass">
	@use "../colors" as colors

	label
		display: block
		color: #ccc

	label[separate]
		line-height: 175%

	.inputBox label
		font-size: 75%
		padding-left: 5px

	select
		width: 100%
		border: none
		border-bottom: 2px solid grey
		background-color: #222
		color: colors.$white

	select[disabled]
		background: unset

	select:focus
		border-color: lightgrey
		outline: none
		transition: border-color 0.2s ease-out
		will-change: border-color

	select.default
		color: grey
</style>